
import { defineComponent } from 'vue'
import BalanceAccount from '@/components/dashboard/BalanceAccount.vue'
import { useTransactionsHistoryStore } from '@/store/transactions/history.store'
import { DeviseType } from '@/helpers/enum'
import { formatDateWithMonthName, sortListOfTransactionDTOByDateDESC } from '@/helpers/functions'
import { TransactionDTOTransactionTypeEnum } from '@/models'
import TransactionItem from '@/components/dashboard/transactions/TransactionItem.vue'
import ExportTransaction from '@/components/dashboard/report/ExportTransaction.vue'

export default defineComponent({
  name: 'TransactionsHistory',
  components: {
    ExportTransaction,
    BalanceAccount,
    TransactionItem
  },
  computed: {
    transactionsStore: function () {
      return useTransactionsHistoryStore()
    },
    sortTransactions: function () {
      return sortListOfTransactionDTOByDateDESC
    },
    formatRangeDate: function (): string {
      if (this.dateRange.length < 2) {
        return ''
      }
      const selectedDate = this.dateRange

      if (new Date(selectedDate[0]) > new Date(selectedDate[1])) {
        const temp = selectedDate[0]
        selectedDate[0] = selectedDate[1]
        selectedDate[1] = temp
      }

      return `${formatDateWithMonthName(new Date(selectedDate[0]))} - ${formatDateWithMonthName(
        new Date(selectedDate[1])
      )}`
    }
  },
  data: function () {
    return {
      menu: false,
      dateRange: [] as string[],
      search: '',
      deviseType: DeviseType,
      chips: undefined as unknown as TransactionDTOTransactionTypeEnum,
      transactionType: TransactionDTOTransactionTypeEnum
    }
  },
  beforeMount() {
    this.transactionsStore.getAllTransactionsByUser()
  },
  watch: {
    date: function () {
      if (this.dateRange === null) {
        this.dateRange = [] as string[]
      }
    }
  },
  methods: {
    transactionByFilterChip: async function () {
      if (!this.chips) {
        await this.transactionByDateRange()
        return
      }
      await this.transactionsStore.getTransactionsByUserAndType(this.chips, this.dateRange)
    },
    handleFilterChange: async function () {
      this.transactionsStore.page = 1
      await this.transactionByFilterChip()
    },
    transactionByDateRange: async function () {
      this.menu = false
      if (this.dateRange.length === 0) {
        await this.transactionsStore.getAllTransactionsByUser()
        return
      }

      // Permute date if date[0] > date[1]
      if (new Date(this.dateRange[0]) > new Date(this.dateRange[1])) {
        const temp = this.dateRange[0]
        this.dateRange[0] = this.dateRange[1]
        this.dateRange[1] = temp
      }

      await this.transactionsStore.getTransactionsByUserAndDateRange(
        new Date(this.dateRange[0]),
        new Date(new Date(this.dateRange[1]).setHours(23, 59, 59)),
        this.chips
      )
    },
    clearDateRange: async function () {
      this.dateRange = [] as string[]
      this.menu = false
      this.transactionsStore.page = 1
      await this.transactionByFilterChip()
    },
    handlePageChange: function (page: number) {
      this.transactionsStore.page = page
      this.transactionByFilterChip()
    }
  }
})
